export default {
    availability_title: {
        label: 'Schedule name',
        placeholder: 'Enter the schedule name.. You can use the name of the person responsible for it.',
        tool_tip_message: 'Enter the schedule name.. You can use the name of the person responsible for it.',
    },

    booking_days_limit: {
        label: 'Allow max days in advance',
        placeholder: 'Enter number',
        tool_tip_message: 'Maximum number of days that users could book the slots in advance.',
    },

    user_availability: {
        users: 'Company users',
        new_users: 'New users',
        admin: 'Admin',
        performer: 'Performer',
        add_user: '+ Add user',
    },
    user_modal: {
        invite_user: 'Do you want to invite user?',
        found_user: 'Found user',
        user_email_not_found: 'User with email:',
        user_email_not_found_1: 'does not exist. Do you want to invite user?',
        user_list: 'User list:',
    },
    errors: {
        user_in_company: 'Choosen user is already in company. To add user, please go to Company users tab!',
        user_already_added: 'Choosen user is already added!',
    },
    modal: {
        heading: 'Do you want to apply the selected slots for multiple days?',
        heading_days: 'Select the days on which you want to apply the chosen slots',
    },
}
